import React from "react";
import AppLoading from "@/components/AppLoading";
import useAuth from "@/hooks/useAuth";

export default function LogoutCallback() {
  const auth = useAuth();

  React.useLayoutEffect(() => {
    auth.logoutCallback();
  }, [auth]);

  return <AppLoading />;
}
